import CustomCarousel from "../components/HomePageCarousel";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import HomePageCard, { homePageCardType } from "../components/HomePageCard";
import { motion } from "framer-motion";
import { baseurl } from "../config";
import homeConstants from "../data/home.json";
import Counter from "../components/framer/Counter";
import { useEffect, useState } from "react";
import Advertisement from "../components/advertisement";

const Home = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isTabView = useMediaQuery(theme.breakpoints.down("md"));
  const [screenHeightRem, setScreenHeightRem] = useState(0);


  const [showAdvertise, setShowAdvertise] = useState<boolean>(true);
  const [closing, setClosing] = useState(false);


  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setShowAdvertise(false);
      setClosing(false);
    }, 400);
  };

  useEffect(() => {
    // Function to calculate screen height in rem
    const calculateScreenHeightInRem = () => {
      const screenHeightPx = window.innerHeight;
      const baseFontSizePx = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      const screenHeightRem = screenHeightPx / baseFontSizePx;
      return screenHeightRem;
    };
    setScreenHeightRem(calculateScreenHeightInRem() - 10.5);

    // Recalculate height on window resize
    const handleResize = () => {
      setScreenHeightRem(calculateScreenHeightInRem() - 10.5);
    };
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Box>
      <Box sx={{ height: `${screenHeightRem}rem` }}>
        <CustomCarousel />
      </Box>
      <Grid
        container
        flexDirection={"column"}
        pt={2}
        justifyContent={"center"}
        alignItems={"center"}
        spacing={2}
        sx={{ backgroundColor: "background.secondary" }}
      >
        <Grid item xs={12}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: "inherit",
              fontSize: "3rem",
              textAlign: "center",
            }}
            component={motion.div}
            initial={{ x: 250, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: { delay: 0.1, duration: 0.3 },
            }}
          >
            {homeConstants?.header}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <motion.span
            style={{
              borderTop: "2px solid #F4AE4A",
              width: "7rem",
              display: "block",
              content: " ",
            }}
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: { duration: 0.5 },
            }}
          ></motion.span>
        </Grid>

        <Grid item xs={12} textAlign={"center"} fontWeight={"500"}>
          <Typography
            sx={{
              fontFamily: "inherit",
              textAlign: "center",
              paddingX: isSmallScreen ? "2rem" : isTabView ? "3rem" : "15rem",
            }}
            component={motion.div}
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: { duration: 0.5, delay: 0.4 },
            }}
          >
            {homeConstants?.description}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          container
          justifyContent={"center"}
          alignItems={"center"}
          spacing={4}
        >
          {homeConstants?.homeCard?.map(
            (cardData: homePageCardType, index: number) => (
              <Grid item>
                <HomePageCard {...cardData} />
              </Grid>
            )
          )}
        </Grid>
      </Grid>

      <Grid
        container
        flexDirection={"column"}
        spacing={4}
        pt={10}
        bgcolor={"background.secondary"}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          textAlign={"center"}
          fontSize={"2.7rem"}
          component={motion.div}
          initial={{ x: -250, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1, transition: { delay: 0.1 } }}
        >
          {homeConstants?.highlights?.header}
        </Grid>

        <Grid
          container
          item
          xs={12}
          mb={4}
          spacing={2}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            container
            justifyContent={"center"}
            item
            xs={12}
            sm={4}
            height={"100%"}
            flexDirection={"column"}
            spacing={3}
          >
            {homeConstants?.highlights?.data?.map((highlights, index) => (
              <Grid
                item
                key={index}
                xs={10}
                sx={{ borderBottom: "1px solid black", marginLeft: "2rem" }}
              >
                <Typography
                  sx={{
                    fontFamily: "inherit",
                    color: "customColors.clr1",
                    fontSize: "2.5rem",
                    margin: "0px",
                  }}
                  component={motion.div}
                  initial={{ scale: 0 }}
                  whileInView={{
                    scale: 1,
                    transition: { duration: 0.5, delay: index * 0.1 },
                  }}
                >
                  {typeof highlights?.figure === "string" ? (
                    <>
                      <Counter
                        value={Number(
                          highlights?.figure?.substring(
                            0,
                            highlights?.figure?.length - 1
                          )
                        )}
                      />
                      {highlights?.figure?.charAt(
                        highlights?.figure?.length - 1
                      )}
                    </>
                  ) : (
                    <Counter value={highlights?.figure} />
                  )}
                  {/* {typeof highlights?.figure === "string" ? (
                    ""
                  ) : (
                    <Counter value={highlights?.figure} />
                  )} */}
                </Typography>
                <Typography
                  sx={{
                    margin: "0px",
                    marginBottom: "0px",
                    fontWeight: "bold",
                    fontFamily: "inherit",
                  }}
                  component={motion.div}
                  initial={{ opacity: 0 }}
                  whileInView={{
                    opacity: 1,
                    transition: { duration: 0.6, delay: (index + 1) * 0.1 },
                  }}
                >
                  {highlights?.achievement}
                </Typography>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <motion.img
              src={`${baseurl}${homeConstants?.highlights?.img}`}
              alt="sideImg"
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
              whileHover={{
                scale: 1.05,
                transition: { duration: 0.4 },
              }}
              whileTap={{ scale: 0.9 }}
              initial={{ scale: 0 }}
              whileInView={{ scale: 1, transition: { duration: 0.4 } }}
            />
          </Grid>
        </Grid>

      </Grid>

      {/* <Grid container spacing={4} pt={10}>
        <Grid
          item
          container
          justifyContent={"center"}
          alignItems={"center"}
          xs={12}
          spacing={4}
          wrap="nowrap"
          px={2}
        >
          <Grid item xs={12} textAlign={"center"}>
            <img
              src=""
              alt="logo"
              style={{
                width: "240px",
              }}
            />
          </Grid>

          <Grid item container xs={12} textAlign={"center"}>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "1.5rem",
                  marginBottom: "0px",
                  fontWeight: "700",
                }}
              >
                ST.XAVIER S SCHOOL PUNE
              </span>
            </Grid>
            <Grid item xs={12}>
              <span style={{ marginTop: "0px" }}>
                Learning Today for Leading Tommorow
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>  */}
       {showAdvertise && <Advertisement className={closing ? "closing" : "opening"} onClose={handleClose} />}
    </Box>
  );
};

export default Home;
